import React, { useEffect, useState } from 'react';

interface ReviewModalProps {
  locationDetails: any;
  location: any;
  subratings: any[];
  reviewCounts: { [key: string]: string };
  closeModal: () => void;
}

interface UserLocation {
    id: string;
    name: string;
  }
  
  interface Avatar {
    thumbnail: string;
    small: string;
    medium: string;
    large: string;
    original: string;
  }
  
  interface User {
    username: string;
    user_location: UserLocation;
    avatar: Avatar;
  }
  
  interface ReviewSubrating {
    name: string;
    localized_name: string;
    rating_image_url: string;
    value: string;
  }
  
  interface OwnerResponse {
    id: number;
    title: string;
    text: string;
    lang: string;
    author: string;
    published_date: string;
  }
  
  interface Review {
    id: number;
    lang: string;
    location_id: number;
    published_date: string;
    rating: number;
    helpful_votes: number;
    rating_image_url: string;
    url: string;
    text: string;
    title: string;
    trip_type: string;
    travel_date: string;
    user: User;
    subratings: { [key: string]: ReviewSubrating };
    owner_response: OwnerResponse;
  }
  
  interface ReviewApiResponse {
    data: Review[];
  }

const ReviewModal: React.FC<ReviewModalProps> = ({ locationDetails, location, subratings, closeModal }) => {
    const [error, setError] = useState<string | null>(null);
    const [locationReview, setLocationReview] = useState<Review[]>([]);
    //const ratingText = ['Terrible', 'Poor', 'Average', 'Very good', 'Excellent'];
    const [expandedReviews, setExpandedReviews] = useState<boolean[]>([]);

    useEffect(() => {
        if (location && location.length > 0) {
          const locationId = location[0].location_id;
          handleFetchLocationReviews(locationId.toString(), 'en');
        }
      }, [location]);

    const toggleExpand = (index: number) => {
        setExpandedReviews((prevExpanded) => {
          const newExpanded = [...prevExpanded];
          newExpanded[index] = !newExpanded[index];
          return newExpanded;
        });
      };

    const handleFetchLocationReviews = async (locationId: string, language: string) => {
        setError(null);
        try {
        const response = await fetch(`https://www.haloholidays.co.uk/api/tripadvisor/reviews?locationId=${encodeURIComponent(locationId)}&language=${encodeURIComponent(language)}`, {
            headers: {
            'Accept': 'application/json',
            },
            // credentials: 'include',
        });

        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.status} - ${response.statusText}`);
        }

        const data: ReviewApiResponse = await response.json();
        if (data) {
            setLocationReview(data.data);
        } else {
            setError('Data is in unexpected format');
        }
        } catch (error: any) {
        console.error('Error fetching data:', error);
        setError(error.message || 'An unexpected error occurred');
        }
    };

    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options);
      };

  return (
    <>
    <div className="modal">
      <div className="modal-content">
        <div className='flex justify-between items-center'>
            <h2 className='text-[1.5rem]'>TRIPADVISOR REVIEWS</h2>
            <div className="close" onClick={closeModal}>&times;</div>
        </div>
        <hr></hr>
        <div className='modal-body mt-2 scrollbar-initial'>
            <div className="flex justify-between items-center pr-2">
                <div>
                    <div className="w-[30%]">
                        <img
                            src="/TripAdvisor/trip_advisor.webp"
                            alt="Tripadvisor logo"
                        />
                    </div>
                    <div className='mt-1'>
                        <img
                            src={locationDetails.rating_image_url}
                            className="h-4 -ml-[4px]"
                            alt={`${locationDetails.rating} of 5`}
                        />
                    </div>
                    <div>
                        <span className="text-sm font-bold ml-1">{locationDetails.rating}/5</span>
                        <span className="text-sm text-gray-900 ml-1">{locationDetails.num_reviews} Reviews</span>
                    </div>
                </div>
                    
                <div className='w-[60%]'>
                    <img 
                        src="/TripAdvisor/tca.webp"
                        alt="Tca logo"
                    />
                </div>
            </div>
            {locationDetails ? (
                <div className='pr-2'>
                    <div className="flex justify-center gap-x-16 mb-4 w-[50%]">
                        <ul className="space-y-1 mt-2 size-full">
                            {subratings.map((subrating: any, index: number) => (
                                <li key={index} className="score flex justify-between items-center ml-1">
                                <div className="label-container">
                                    <span className="text-gray-700 text-sm">{subrating.localized_name}</span>
                                </div>
                                <div className="flex items-center mr-1">
                                    <img
                                    src={subrating.rating_image_url}
                                    className="h-3"
                                    alt={`${subrating.value} of 5`}
                                    />
                                    <span className="ml-2 text-gray-700 text-sm">{subrating.value}</span>
                                </div>
                                </li>
                            ))}
                        </ul>
                        {/* <ul className='space-y-1 mt-2 size-full'>
                            {Object.entries(reviewCounts).reverse().map(([rating, count], index) => {
                                const numericCount = parseFloat(count);
                                const totalReviewCount = locationDetails.num_reviews;
                                let adjustedReviewCount;
                                if (totalReviewCount >2000) {
                                    adjustedReviewCount = isNaN(numericCount) ? 0 : (numericCount / 100).toFixed(0);
                                } else {
                                    adjustedReviewCount = isNaN(numericCount) ? 0 : (numericCount / 10).toFixed(0);
                                }
                                
                                return (
                                <li key={index}>
                                    <div className='flex justify-between items-center'>
                                    <div className='text-sm ml-1 text-gray-700'>{ratingText[parseInt(rating) - 1]}</div>
                                    <div className="progress-container">
                                        <div className="progress-bar" style={{ width: `${adjustedReviewCount}%` }}></div>
                                    </div>
                                    </div>
                                    
                                </li>
                                );
                            })}
                        </ul> */}
                    </div>
                    <hr></hr>
                    
                    {locationReview.map((review, index) => (
                    <div key={index} className='mt-2'>
                        <h3 className="text-lg">{review.title}</h3>
                        <img src={review.rating_image_url} className="my-2 -ml-[12px]" alt={`${review.rating} of 5`} />
                        <div className="flex items-center justify-left">
                        <div className="contributor text-gray-700">{review.user.username}</div>
                        <span className="date text-gray-500 mx-2"> | </span>
                        <span className="text-gray-500">{formatDate(review.published_date)}</span>
                        </div>
                        <p className="text-gray-600">{review.text}</p>
                        {review.owner_response && (
                        <div className="bg-gray-100 p-4 mt-4 rounded-lg shadow">
                            <h4 className="text-md font-bold">{review.owner_response.title}</h4>
                            <div className="text-gray-700" dangerouslySetInnerHTML={{ __html: review.owner_response.text }}></div>
                            <div className="text-gray-500 text-sm">{formatDate(review.owner_response.published_date)}</div>
                        </div>
                        )}

                    {expandedReviews[index] && (
                    <div className="flex justify-start gap-x-24 mt-4">
                        <ul className="space-y-2 mt-2 md:w-[35%]">
                        {Object.values(review.subratings || {}).map((subrating, index) => (
                            <li key={index} className="score flex justify-between items-center">
                            <div className="label-container">
                                <span className="text-gray-700">{subrating.localized_name}</span>
                            </div>
                            <div className="flex items-center">
                                <img
                                src={subrating.rating_image_url}
                                className="h-4"
                                alt={`${subrating.value} of 5`}
                                />
                                <span className="ml-2 text-gray-700">{subrating.value}</span>
                            </div>
                            </li>
                        ))}
                        </ul>
                    </div>
                    )}

                    {Object.values(review.subratings || {}).length === 0 ? '' : 
                        <button
                            onClick={() => toggleExpand(index)}
                            className="mt-4 text-blue-600 font-medium hover:text-red-700 focus:outline-none text-sm"
                        >
                            {expandedReviews[index] ? (
                                <>
                                Less <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 inline-block align-middle" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M16.707 11.293a1 1 0 01-1.414 1.414L10 7.414l-5.293 5.293a1 1 0 11-1.414-1.414l6-6a1 1 0 011.414 0l6 6z" clipRule="evenodd" />
                                </svg>
                            </>
                            ) : (
                            <>
                                More <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 inline-block align-middle" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M3.293 8.293a1 1 0 011.414 0L10 13.586l5.293-5.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                            </>
                            )}
                        </button>
                    }
                    
                    <hr className="my-4" />

                    
                    
                    </div>
                    ))}
                    {locationReview.length > 0 && (
                        <div className='flex items-center text-md text-blue-600 cursor-pointer'>
                            <a href={locationReview[0].url} target="_blank" rel="noopener noreferrer" className='mr-1'>View All {locationDetails.num_reviews} reviews on TripAdvisor website</a>
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" className='text-blue-600 fill-current' width="16px" height="16px" viewBox="0 0 1024 1024">
                                <path d="M948.053 133.973l-456.533 457.387c-14.507 14.507-38.4 14.507-53.76 0-14.507-14.507-14.507-38.4 0-53.76l456.533-456.533h-98.133c-21.333 0-37.547-17.067-37.547-37.547s17.067-37.547 37.547-37.547h189.44c21.333 0 37.547 17.067 37.547 37.547v189.44c0 21.333-17.067 37.547-37.547 37.547s-37.547-17.067-37.547-37.547v-98.987zM853.333 506.88c0-21.333 17.067-37.547 37.547-37.547s37.547 17.067 37.547 37.547v352.427c0 87.893-71.68 159.573-159.573 159.573h-609.28c-87.893 0-159.573-71.68-159.573-159.573v-609.28c0-87.893 71.68-159.573 159.573-159.573h352.427c21.333 0 37.547 17.067 37.547 37.547s-17.067 37.547-37.547 37.547h-352.427c-46.080 0-83.627 37.547-83.627 83.627v609.28c0 46.080 37.547 83.627 83.627 83.627h609.28c46.080 0 83.627-37.547 83.627-83.627v-351.573z"></path>
                            </svg>
                        </div>
                    )}
                </div>
                
            ) :  (
                <div className="text-gray-700 mt-2 text-center">
                {error ? (
                    <div className="text-red-500">Error: {error}</div>
                ) : (
                    <div>Loading...</div>
                )}
                </div>
            )}
            
        </div>
      </div>
    </div>
    </>
  );
};

export default ReviewModal;
